import { createSlice } from "@reduxjs/toolkit";

import { IS_DEV } from "../config";
import { storage } from "../utils/storage";

export type WixUser = {
  accessToken: string;
  wixInstanceId: string;
  vendorProductId: string;
};

const getUserData = (): AppState["wixUser"] => {
  const searchParams = new URLSearchParams(window.location.search);
  const accessToken = searchParams.get("token") || "";
  const wixInstanceId = searchParams.get("wixInstanceId") || "";
  const vendorProductId = searchParams.get("vendorProductId") || "free";

  if (IS_DEV) {
    if (accessToken) {
      storage.setItem("wixDevAccessToken_rp", accessToken);
    }

    if (wixInstanceId) {
      storage.setItem("wixDevInstanceId_rp", wixInstanceId);
    }

    return {
      accessToken: accessToken || storage.getItem("wixDevAccessToken_rp"),
      wixInstanceId: wixInstanceId || storage.getItem("wixDevInstanceId_rp"),
      vendorProductId,
    };
  }

  return {
    accessToken,
    wixInstanceId,
    vendorProductId,
  };
};

interface AppState {
  wixUser: WixUser;
}

const initialState: AppState = {
  wixUser: getUserData(),
};

export const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {},
});
